import type { UserProfile } from '@/types/user';

let rolloutFlags: Record<string, boolean> = {};

const isRolloutFlagEnabled = (key: string) => {
  return rolloutFlags[key] ?? false;
};

const rolloutFlagsSetup = (userProfile: UserProfile) => {
  rolloutFlags = { ...userProfile?.rollout_flags };
};

export { isRolloutFlagEnabled, rolloutFlagsSetup };
